import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';

export default function MediaCard({ imageLink, title, text }) {
  const [isHovered, setIsHovered] = React.useState(false);

  const cardStyle = {
    maxWidth: 320,
    backgroundColor: `rgba(255, 255, 255, ${isHovered ? 0.5 : 0.25})`,
    backdropFilter: 'blur(10px)',
    transition: 'background-color 0.3s, backdrop-filter 0.3s',
    cursor: 'pointer', // Add cursor style on hover
    marginRight:"10px",
  };

  const cardMediaStyle = {
    height: '210px',
  };

  const cardContentStyle = {
    padding: '30px',
    height: '200px',
  };

  return (
    <Card
      style={cardStyle}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <CardMedia
        style={cardMediaStyle}
        image={imageLink}
        title="green iguana"
      />
      <CardContent style={cardContentStyle}>
        <Typography gutterBottom variant="h5" component="div">
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {text}
        </Typography>
      </CardContent>
    </Card>
  );
}
